(ns ui.view.entry-criteria.event
  (:require
   [potpuri.core :as potpuri]
   [re-frame.core :as rf]
   [ui.view.entry-criteria.model :as m]))

(defn set-association
  "Stores the multi-select value for one association under the modal's root
   ident. `val` is a vector of `{:value entity-id :label name}` option maps,
   matching opportunity-creator's storage shape. An empty val clears the slot
   so the criterion-not-yet-satisfied check stays simple."
  [{:keys [db]}
   [_ {:keys [ident association-key val]}]]
  (let [val (when (seq val) val)
        path (conj (m/associations-edits-full-path ident) association-key)
        new-db (if val
                 (assoc-in db path val)
                 (potpuri/dissoc-in db path))]
    {:db new-db}))

(rf/reg-event-fx
 m/set-association
 #'set-association)

(defn clear-state
  "Drops the entire entry-criteria state tree for this modal instance.
   Called from cancel!/submit-and-close! so a re-opened modal starts clean."
  [{:keys [db]}
   [_ {:keys [ident]}]]
  {:db (potpuri/dissoc-in db (m/i-root ident))})

(rf/reg-event-fx
 m/clear-state
 #'clear-state)
